<template>
  <div>
    <list
      row-key="HouseId"
      ref="list"
      unit="任课资料"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      :can-search="canSearch"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称" v-if="isMB">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="isDialog">
          <el-form-item label="年级">
            <el-select v-model="params.GradeId" @change="getClasses" clearable>
              <el-option
                v-for="(i,key) in gradeList"
                :key="key"
                :label="i.Grade"
                :value="i.GradeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级">
            <el-select v-model="params.ClassId" clearable>
              <el-option
                v-for="item in classes"
                :key="item.ClassId"
                :value="item.ClassId"
                :label="item.ClassName"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="班级" v-if="isMB&&!isDialog">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TreeData"
            :value="params.ClassId"
            :clearable="false"
            :accordion="true"
            style="width:100%"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请填写学生姓名" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ClassName" label="班级" min-width="100" />
        <el-table-column prop="StudentNumber" label="学生编号" min-width="120" />
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column prop="Courses" label="选修" min-width="150" show-overflow-tooltip />
        <el-table-column prop="SeatNumber" label="座位号">
          <template slot-scope="{row}">
            <span v-if="!$permission.canWrite()||isDialog">{{row.SeatNumber}}</span>
            <el-button
              type="text"
              v-else-if="row.SeatNumber"
              @click="onSeatDialog(row)"
            >{{row.SeatNumber}}</el-button>
            <el-button type="text" v-else @click="onSeatDialog(row)">设置</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="CardNumber" label="卡号" min-width="110px" />
        <el-table-column prop="Dormitory" label="宿舍号">
          <template slot-scope="{row}">
            <span v-if="!$permission.canWrite()||isDialog">{{row.DormitoryId}}</span>
            <el-button
              type="text"
              v-else-if="row.DormitoryId"
              @click="onDormDialog(row)"
            >{{row.Dormitory}}</el-button>
            <el-button type="text" v-else @click="onDormDialog(row)">设置</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ParentName1" label="家长姓名1" min-width="100" />
        <el-table-column prop="ContactNumber1" label="联系电话1" min-width="110" />
        <el-table-column prop="ParentName2" label="家长姓名2" min-width="100" />
        <el-table-column prop="Call2" label="联系电话2" min-width="110" />
        <el-table-column prop="ParentName3" label="家长姓名3" min-width="100" />
        <el-table-column prop="ContactNumber3" label="联系电话3" min-width="110" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <dorm-dialog ref="dormDialog" in-dialog selectable :multiple="false" @select="setDorm" />
    <seat-dialog ref="seatiDalog" @setSeat="setSeat" />
    <detail-dialog ref="detailDialog" />
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import detailDialog from "./detailDialog";
import dormDialog from "@/components/lo/dorm/listDialog";
import seatDialog from "@/components/st/sc/seatDialog";
import treeSelect from "@/components/common/treeSelect";
import classApi from "@/api/ed/class";
import termApi from "@/api/ed/term";
import exportDialog from "./exportDialog";
import { parse } from "path-to-regexp";

export default {
  mixins: [listMixin],
  components: {
    list,
    detailDialog,
    dormDialog,
    seatDialog,
    treeSelect,
    exportDialog,
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/st/studentclass").default,
      teacher_api: require("@/api/fa/teacher").default,
      gradeApi: require("@/api/ed/grade").default,
      termApi,
      classApi,
      params: {
        FullName: "",
        ClassId: null,
        TermId: null,
        GradeId: null,
        TeacherId: null,
      },
      props: {
        // 配置项（必选）
        value: "ClassId",
        label: "ClassName",
        children: "children",
        // disabled:true
      },
      classes: [],
      row: {},
      termList: [],
      TreeData: [],
      gradeList: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    if (this.isMB) {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        if (res.Data.length > 0) {
          let tid = res.Data[0].TermId;
          this.params.TermId = tid;
          this.getTreeData(tid);
          this.getData({ TermId: tid });
          sessionStorage.setItem("termId", tid);
        }
      });
    }
  },
  methods: {
    getClasses() {
      var TermId = this.params.TermId;
      var TeacherId = this.params.TeacherId;
      var GradeId = this.params.GradeId;
      this.teacher_api.getMsgClasses(TermId, TeacherId, GradeId).then((res) => {
        if (res.Data) this.classes = res.Data;
        else this.$message.error("获取班级失败");
        // if (this.classes.length > 0) {

        // }
        console.log("params", this.params);
        this.query(this.params);
        // console.log("this.classes", this.classes);
      });
    },
    reset() {
      this.params.FullName = "";
      this.params.ClassId = null;
    },
    getGrade(TermId, TeacherId) {
      this.gradeApi.list().then((res) => {
        if (res.Data) this.gradeList = res.Data;
        else this.$message.error("获取年级失败");
        if (this.gradeList.length > 0) {
          this.params.GradeId = this.gradeList[0].GradeId;
          this.params.TermId = TermId;
          this.params.TeacherId = TeacherId;
          this.getClasses(TermId, TeacherId);
        }
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export(params) {
      params = { ...this.params, ...params };
      params = this.$commonJs.obj.removeNullKey(params);
      console.log("params", params);
      this.$refs.exportDialog.open().then((that) => {
        that.getData(params);
      });
    },
    getTreeData(termId) {
      classApi.gradeClassList(termId).then((res) => {
        sessionStorage.setItem("termId", termId);
        this.TreeData = this.$commonJs.toTreeData(res.Data, "ClassId");
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      this.getTreeData(e);
      this.getData({ TermId: e });
      this.$refs.treeSelect.clearHandle();
    },
    onTreeSelect(t) {
      if (!t) return;
      if (t.Lv == 2) {
        this.getData({ ClassId: t.ClassId, TermId: this.params.TermId });
        this.$emit("setadd", true);
      } else {
        this.getData({ GradeId: -t.ClassId, TermId: this.params.TermId });
        this.$emit("setadd", false);
      }
    },
    detail(row) {
      this.$refs.detailDialog.openDetails(row);
    },
    onSeatDialog(row) {
      this.row = row;
      this.$refs.seatiDalog.open(row.SeatNumber);
    },
    setSeat(num) {
      this.api.setSeatNumber(this.row.StudentClassId, num).then((res) => {
        if (res.Code == 0) {
          this.$message.success("修改座位号成功");
          this.reload();
          this.$refs.seatiDalog.close();
        } else {
          this.$message.error("修改失败" + res.Msg);
        }
      });
    },
    onDormDialog(row) {
      this.row = row;
      this.$refs.dormDialog.open().then((that) => {
        that.getData();
      });
    },
    setDorm(dorm) {
      this.api
        .setDormitory({
          termId: sessionStorage.getItem("termId"),
          studentDormitoryId: this.row.StudentDormitoryId,
          dormitoryId: dorm.DormitoryId,
          StudentId: this.row.StudentId,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success("修改宿舍成功");
            this.reload();
          } else {
            this.$message.error("修改失败，" + res.Msg);
          }
        });
    },
  },
};
</script>